import React from 'react';
import IntelligentVideo from '../../../Assets/images/Omni/ClinicalNote/intelligent-interoperability.webm';
import IntelligentVideoMp from '../../../Assets/images/Omni/ClinicalNote/intelligent-interoperability.mp4';

const IntelligentInteroperability = () => {
    return (
        <div className='aug-efficient-documentation__item'>
            <div className="row align-items-center flex-lg-row flex-column-reverse">
                <div className='offset-xl-1 col-12 col-md-10 col-lg-5 col-xl-4'>
                    <div className='aug-efficient-documentation__video'>
                        <div className="mx-xl-4">
                            <video width="100%" id='videoDictation' playsInline muted autoPlay="autoPlay" preload="metadata" loading="lazy" loop="loop">
                                <source src={IntelligentVideo} type="video/webm" />
                                <source src={IntelligentVideoMp} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>
                <div className='offset-lg-1 col-md-12 col-lg-6'>
                    <div className='aug-efficient-documentation__content'>
                        <h6 className='mb-2'>STEP 4</h6>
                        <h3 className='mb-3'>Intelligent Interoperability</h3>
                        <p className='mb-0'>We offer deep integrations as well as low code and no-code options, so you can pull and push live data seamlessly. No copy-paste required. Minimize time spent filling out EMR systems and maximize time with your patients.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntelligentInteroperability;